
































































import Vue from "vue";
import { RoomCommandParameterTypes, RoomDetail } from "@/models/room";
import RoomService from "@/services/roomService";
import { RoomCommandTypes } from "@/models/room";
import FileUtil from "@/utils/fileUtil";
import { FileFormatted } from "@/models/file";
import VaButton from "@/components/atoms/VaButton.vue";
import clone from "lodash/clone";

export default Vue.extend({
  name: "LoggingAndroid",
  // name: "RoomRemoteManagementAndroid",
  components: {
    VaButton,
  },
  data() {
    return {
      sending: false,
      downloading: false,
      updating: false,
      polling: 0,
      script: null as unknown as FileFormatted,
      scriptRunAsSystem: false,
      currentLogLevel:
        this.$store.getters["room/room"]?.machineLogConfiguration || 0,
      logLevels: [
        { value: 0, text: this.$t("roomCommands.none") },
        { value: 1, text: this.$t("roomCommands.error") },
        { value: 2, text: this.$t("roomCommands.warn") },
        { value: 3, text: this.$t("roomCommands.info") },
        { value: 4, text: this.$t("roomCommands.debug") },
        { value: 5, text: this.$t("roomCommands.verbose") },
      ],
    };
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  methods: {
    async sendCommand(
      command: RoomCommandTypes,
      parameter: RoomCommandParameterTypes
    ): Promise<void> {
      if (this.commandControlsDisabled) return;
      this.sending = true;
      try {
        await RoomService.sendCommand(command, parameter);
        this.$notification.success(this.$t("roomCommands.commandSuccess"));
        if (command === RoomCommandTypes.SCRIPT) {
          (
            this.$refs.scriptUploader as Vue & { removeFile: () => void }
          ).removeFile();
          this.scriptRunAsSystem = false;
        }
      } catch (e) {
        this.$notification.error(e);
        this.$sentry.capture(e, "RoomRemoteManagement", "sendCommand");
      } finally {
        this.sending = false;
      }
    },
    async stopDownload() {
      clearInterval(this.polling);
      this.downloading = false;
      this.$notification.warning(this.$t("common.downloadAborted"));
    },
    async downloadLog() {
      if (this.commandControlsDisabled) return;
      this.downloading = true;
      try {
        const commandId = await RoomService.sendCommand(RoomCommandTypes.LOG);
        this.polling = setInterval(async () => {
          const res = await RoomService.getCommand(this.room.id, commandId);
          if (res.status === 6) {
            clearInterval(this.polling);
            FileUtil.downloadByResource(
              res.response,
              (this.$store.getters["room/room"] as RoomDetail).id + "_log",
              "zip"
            );
            this.$notification.success(this.$t("roomCommands.logSuccess"));
            this.downloading = false;
          }
        }, 1500);
      } catch (e) {
        this.$notification.error(e);
        this.$sentry.capture(e, "RoomRemoteManagement", "downloadLog");
        this.downloading = false;
      }
    },
    async changeLogLevel() {
      if (this.commandControlsDisabled) return;
      try {
        this.updating = true;
        // const commandId =
        await RoomService.sendCommand(
          RoomCommandTypes.LOGLEVEL,
          this.currentLogLevel
        );
        // this.polling = setInterval(async () => {
        //   const res = await RoomService.getCommand(this.room.id, commandId);
        //   if (res.status === 6) {
        //     clearInterval(this.polling);
        //     this.$notification.success(this.$t("roomCommands.logLevelSuccess"));
        //     this.updating = false;
        //   }
        // }, 1500);
        this.updating = false;
      } catch (e) {
        this.$notification.error(e);
        this.$sentry.capture(e, "RoomRemoteManagement", "changeLogLevel");
        this.updating = false;
      }
    },
  },
  computed: {
    commandControlsDisabled(): boolean {
      return !this.room?.online || !!this.room?.isMaintenanceExpired;
    },
    room(): RoomDetail {
      return clone(this.$store.getters["room/room"]);
    },
  },
});
